import { statsOnWidgetInteraction } from '../stats';

export function sliderSwiperWindow() {
	if (document.querySelectorAll('.swiper__container.__ver_window').length) {
		document.querySelectorAll('.swiper__container.__ver_window').forEach((gallery) => {
			const gallerySlider = gallery.querySelector('.gallery-slider');
			const btnPrev = gallery.querySelector('.swiper-button-prev');
			const btnNext = gallery.querySelector('.swiper-button-next');
			const slidesLength = gallerySlider.querySelectorAll('.swiper-slide').length;			
			let realIdx = 0;
			const swiper = new Swiper(gallerySlider, {
				slidesPerView: 1,
				effect: "fade",
				centeredSlides: true,
				loop: true,
				spaceBetween: 0,
				freeMode: true,
				navigation: {
					nextEl: btnPrev,
					prevEl: btnNext,
				},
				on: {
					realIndexChange() {
						const eventAction =
						'ontouchstart' in document.documentElement ? 'tap' : 'click';
						const evType = this.swipeDirection ? 'swipe' : eventAction;
						const item = this.el.querySelector(
						`[data-swiper-slide-index="${this.realIndex}"]`
						);
						statsOnWidgetInteraction(
						item,
						item.querySelector('img').getAttribute('src'),
						this.realIndex,
						evType
						);
						realIdx = this.realIndex;
					},
				},
			});

		});
	}
}

export function sliderSwiperWide() {
	if (document.querySelectorAll('.swiper__container.__ver_single').length) {
		document.querySelectorAll('.swiper__container.__ver_single').forEach((gallery) => {
			const gallerySlider = gallery.querySelector('.gallery-slider');
			const btnPrev = gallery.querySelector('.swiper-button-prev');
			const btnNext = gallery.querySelector('.swiper-button-next');
			const pagination = gallery.querySelector('.swiper-pagination');
			const slidesLength = gallerySlider.querySelectorAll('.swiper-slide').length;
			let realIdx = 0;
			let lastIndex = 0;
			let swiper = new Swiper(gallerySlider, {
				loop: true,				
				autoHeight: true,				
				slidesPerView: 1,				
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				  },				  
				pagination: {
					el: pagination,
				},				

				on: {
					realIndexChange() {
						const eventAction =
						'ontouchstart' in document.documentElement ? 'tap' : 'click';
						const evType = this.swipeDirection ? 'swipe' : eventAction;
						const item = this.el.querySelector(
						`[data-swiper-slide-index="${this.realIndex}"]`
						);
						statsOnWidgetInteraction(
						item,
						item.querySelector('img').getAttribute('src'),
						this.realIndex,
						evType
						);
						realIdx = this.realIndex;
					},
				},
		  
				
				
				/*,
				on: {
					'init': (swiper) => {
						lastIndex = swiper.realIndex;
					},
					'realIndexChange': (swiper) => {
						swiper.realIndex;
					}
				}*/				
			});
		});
	}
}